import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { MainActionButton } from '../Buttons/MainActionButton';
import { LocalizationManager } from '../../../localization/LocalizationManager';

interface BlockNavigationModalBaseProps {
    onConfirm: () => void;
    onCancel: () => void;
    localization: LocalizationManager;
    isOpen: boolean;
    isHighAlertButton: boolean;
    title: string;
    body: string;
    cancelButtonText: string;
    confirmButtonText: string;
}

export const BlockNavigationModalBase = (props: BlockNavigationModalBaseProps) => {
    const {
        localization,
        onConfirm,
        isOpen,
        onCancel,
        title,
        body,
        cancelButtonText,
        confirmButtonText,
        isHighAlertButton
    } = props;
    const _onConfirm = () => {
        onConfirm();
    };
    const _onCancel = (_event: React.SyntheticEvent, reason?: string) => {
        if (reason !== 'backdropClick') {
            onCancel();
        }
    };

    return (
        <Dialog open={isOpen} onClose={_onCancel}>
            <DialogTitle>{localization.getText(title)}</DialogTitle>
            <DialogContent>
                <DialogContentText>{localization.getText(body)}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={_onCancel}
                    color={isHighAlertButton ? 'inherit' : 'primary'}
                    variant={isHighAlertButton ? 'text' : 'contained'}
                >
                    {localization.getText(cancelButtonText)}
                </Button>
                <MainActionButton onClick={_onConfirm} autoFocus $highAlertButton={isHighAlertButton}>
                    {localization.getText(confirmButtonText)}
                </MainActionButton>
            </DialogActions>
        </Dialog>
    );
};
